import type { MessagingGetChatRooms200PageAllOfThreeContentItemBasicInfo } from './messagingGetChatRooms200PageAllOfThreeContentItemBasicInfo';
import type { MessagingGetChatRooms200PageAllOfThreeContentItemLastMessage } from './messagingGetChatRooms200PageAllOfThreeContentItemLastMessage';
import type { MessagingGetChatRooms200PageAllOfThreeContentItemParticipantsItem } from './messagingGetChatRooms200PageAllOfThreeContentItemParticipantsItem';
import type { MessagingGetChatRooms200PageAllOfThreeContentItemTimeInfo } from './messagingGetChatRooms200PageAllOfThreeContentItemTimeInfo';

export type MessagingGetChatRooms200PageAllOfThreeContentItem = {
  basicInfo?: MessagingGetChatRooms200PageAllOfThreeContentItemBasicInfo;
  /** 마지막 메시지 */
  lastMessage?: MessagingGetChatRooms200PageAllOfThreeContentItemLastMessage;
  /** 참여자 목록 */
  participants?: MessagingGetChatRooms200PageAllOfThreeContentItemParticipantsItem[];
  /** 시간 관련 정보 */
  timeInfo?: MessagingGetChatRooms200PageAllOfThreeContentItemTimeInfo;
};
